import { css } from '@emotion/react';
import React, { ReactNode } from 'react';
import { colors, spacing } from '../../../utils/styleguide';

type Props = {
  children: ReactNode;
};

const BannerWrapper = ({ children }: Props) => {
  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1;
      `}
    >
      <div
        css={css`
          margin: ${spacing[1]}px;
          margin-bottom: 0;
          background-color: ${colors.lightGreen};
          padding: ${spacing[1]}px ${spacing[2]}px;
          max-width: 780px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          width: 100%;
          overflow: hidden;
          box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12), 0px 14px 24px rgba(0, 0, 0, 0.16);
        `}
      >
        {children}
      </div>
    </div>
  );
};

export default BannerWrapper;
